import { render, staticRenderFns } from "./Owner.vue?vue&type=template&id=28c2df32&scoped=true&"
import script from "./Owner.vue?vue&type=script&lang=js&"
export * from "./Owner.vue?vue&type=script&lang=js&"
import style0 from "./Owner.vue?vue&type=style&index=0&id=28c2df32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c2df32",
  null
  
)

export default component.exports